export default __webpack_public_path__ + "static/media/PP_SLA_Sosnowiec_Szkolna.90499f92.webp";